import axios from 'axios';
import * as _ from 'lodash';

class ConveniadoService {

    //CAP-47 - Retorna os vouchers de um pedido(salesOrderId) para retirada da TAG em um conveniado:
    listaVouchersConveniado(request){
        return axios.post('/v2/conveniado/listaVouchersConveniado', request).then(res => res.data);
    }

    //CAP-47 - Retorna nome e endereco de todos os conveniados:      
    listaConveniados(){
        return axios.get('/v2/conveniado/listaConveniados').then(res => {
            return res.data;
        });      
    }

    listaVouchersConveniadoComStatus(request){
        return axios.post('/v2/conveniado/listaVouchersConveniadoComStatus', request).then(res => res.data);
    }

}

// Singleton
const instance = new ConveniadoService();

export default instance;


// WEBPACK FOOTER //
// ./src/services/conveniado-service.js